import 'react-toastify/dist/ReactToastify.css'
import { ToastContainer } from 'react-toastify'

const ToastNotification = () => (
  <ToastContainer icon={false} toastClassName='c-toastify' />
)

export default ToastNotification
